const INITIAL_STATE = {
  data: {},
  errors: {},

}
const getMonthForecastTotal = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_MONTHLY_FORECAST_TOTAL_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_MONTHLY_FORECAST_TOTAL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getMonthForecastTotal;